/*
 * Copyright (c) 2022 Reservo LLC. All rights reserved.
 */
// @codekit-prepend "bin/time.js"
// @codekit-prepend "bin/shared.js"
// @codekit-prepend "bin/notifications.js";
// @codekit-prepend "bin/actions.js"
// @codekit-prepend "bin/front/main.js"


// DOCUMENT READY
jQuery(document).ready(function( $ ) {

    reservo_init_customer_dashboard_login();
    reservo_init_customer_dashboard();

    if(reservo_helper.start_from_booking_intent_key){

      var data = { 
        action: reservo_helper.route_action,
        route_name: reservo_helper.start_from_booking_intent_route, 
        params: { booking_intent_key: reservo_helper.start_from_booking_intent_key }, 
        layout: 'none', 
        return_format: 'json' 
      }

      $.ajax({
        type : "post",
        dataType : "json",
        url : reservo_helper.ajaxurl,
        data : data,
        success: function(data){
          if(data.status === "success"){
            var lightbox_class = '';
            reservo_show_data_in_lightbox(data.message, data.lightbox_class);
            var $booking_form_element = jQuery('.reservo-lightbox-w .reservo-booking-form-element');
            reservo_init_booking_form($booking_form_element);
            $booking_form_element.find('.reservo-step-content').addClass('is-hidden').last().removeClass('is-hidden');
            if($booking_form_element.find('.reservo-step-content').length > 1) reservo_show_prev_btn($booking_form_element);
            var $booking_form_element = jQuery('.reservo-lightbox-w .reservo-booking-form-element');
            $booking_form_element.find('.reservo-step-content').each(function(){
              reservo_init_step($(this).data('step-name'), $booking_form_element);
            });
            $('body').addClass('reservo-lightbox-active');
          }else{
            // console.log(data.message);
          }
        }
      });
    }

    if(jQuery('.reservo-booking-form-element').length){
      jQuery('.reservo-booking-form-element').each(function(){
        reservo_init_booking_form(jQuery(this));
        reservo_init_step(jQuery(this).find('.reservo_current_step').val(), jQuery(this));
      });
    }


    jQuery('body').on('click', '.reservo-lightbox-close', function(){
      reservo_lightbox_close();
      return false;
    });


    jQuery('.reservo-request-booking-cancellation').on('click', function(){
      if(!confirm(reservo_helper.cancel_booking_prompt)) return false;
      var $this = jQuery(this);
      var $booking_box = $this.closest('.customer-booking');

      var route = jQuery(this).data('route');
      var params = {id: $booking_box.data('id')};

      var data = { action: reservo_helper.route_action, route_name: route, params: params, layout: 'none', return_format: 'json' }
      $this.addClass('os-loading');
      $.ajax({
        type : "post",
        dataType : "json",
        url : reservo_helper.ajaxurl,
        data : data,
        success: function(data){
          if(data.status === "success"){
            location.reload();
            $this.remove();
          }else{
            $this.removeClass('os-loading');
          }
        }
      });
      return false;
    });


    jQuery('body').on('click', '.os-step-tabs .os-step-tab', function(){
      jQuery(this).closest('.os-step-tabs').find('.os-step-tab').removeClass('active');
      jQuery(this).addClass('active');
      var target = jQuery(this).data('target');
      jQuery(this).closest('.os-step-tabs-w').find('.os-step-tab-content').hide();
      jQuery(target).show();
    });

    jQuery('body').on('keyup', '.os-form-group .os-form-control', function(){
      if(jQuery(this).val()){
        jQuery(this).closest('.os-form-group').addClass('has-value');
      }else{
        jQuery(this).closest('.os-form-group').removeClass('has-value');
      }
    });

    jQuery('.reservo-tab-triggers').on('click', '.reservo-tab-trigger', function(){
      var $tabs_wrapper = jQuery(this).closest('.reservo-tabs-w')
      $tabs_wrapper.find('.reservo-tab-trigger.active').removeClass('active');
      $tabs_wrapper.find('.reservo-tab-content').removeClass('active');
      jQuery(this).addClass('active');
      $tabs_wrapper.find('.reservo-tab-content' + jQuery(this).data('tab-target')).addClass('active');
      return false;
    });


    // Main Button to trigger lightbox opening
    jQuery('body').on('click', '.reservo-book-button, .os_trigger_booking', function(){
      reservo_init_booking_form_by_trigger(jQuery(this));
      return false;
    });

});
